module.exports = __webpack_public_path__ + "static/revolution-accomplished_700px-0b0213d1930ad82a7ce06b03c0f4f4c7.jpg";